/**
 * @file index.jsx
 * @author Daniel Aguirre
 * @description Adherence card
 */

// Dependencies
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderedListOutlined } from '@ant-design/icons';

import {
  STAGE_INDICATOR,
  ADHERENCE_INDICATOR
} from '@nephro/pages/Indicators/helpers/constants';

// Hooks
import usePatientIndicators from '@nephro/pages/Indicators/helpers/usePatientIndicators';

// Components
import DashboardPatientCard from '../dashboardPatientCard';

const AdherenceCard = () => {
  const [stage] = usePatientIndicators(STAGE_INDICATOR);
  const [adherenceIndicator] = usePatientIndicators(ADHERENCE_INDICATOR);
  const { t: translate } = useTranslation();
  const [data, setData] = useState(null);

  const title = translate('dashboardPatient.adherenceTitle');

  useEffect(() => {
    if (stage && adherenceIndicator !== undefined) {
      const componentData = {
        title,
        link: 'patient-adherence',
        mainIcon: (
          <OrderedListOutlined
            style={{
              fontSize: 40,
              color: 'var(--color-card-blueSmoke)',
              backgroundColor: 'white',
              padding: 3,
              borderRadius: 10
            }}
          />
        ),
        background: 'bg-cardBlueSmoke'
      };
      setData(componentData);
    }
  }, [title, stage]);

  return <DashboardPatientCard data={data} />;
};

export default AdherenceCard;
